import { useEffect, useState } from "react";
import { Reveal } from "./Reveal";

const TARGET = new Date("2026-10-10T14:00:00-04:00").getTime();
const pad = (n) => String(n).padStart(2, "0");

export const Countdown = () => {
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  const diff = Math.max(0, TARGET - now);
  const units = [
    { value: Math.floor(diff / 86400000), label: "Días", testid: "countdown-days" },
    { value: pad(Math.floor((diff % 86400000) / 3600000)), label: "Horas", testid: "countdown-hours" },
    { value: pad(Math.floor((diff % 3600000) / 60000)), label: "Minutos", testid: "countdown-minutes" },
    { value: pad(Math.floor((diff % 60000) / 1000)), label: "Segundos", testid: "countdown-seconds" },
  ];

  return (
    <section data-testid="countdown-section" className="bg-cream py-24 md:py-32 px-6">
      <Reveal>
        <p className="font-script text-clay text-3xl md:text-4xl text-center">Cuenta regresiva</p>
        <p className="mt-4 text-center text-[11px] uppercase tracking-[0.35em] text-stone">
          Para el 10 de octubre de 2026 · 2:00 PM
        </p>
        <div className="mt-14 flex justify-center items-start">
          {units.map((u, i) => (
            <div key={u.label} className="flex items-start">
              {i > 0 && <span className="font-serif text-4xl md:text-6xl text-clay/25 mx-4 md:mx-10 leading-none">·</span>}
              <div className="text-center">
                <p data-testid={u.testid} className="font-serif text-5xl md:text-7xl text-ink tabular-nums leading-none">
                  {u.value}
                </p>
                <p className="mt-3 text-[10px] md:text-[11px] uppercase tracking-[0.35em] text-stone">{u.label}</p>
              </div>
            </div>
          ))}
        </div>
      </Reveal>
    </section>
  );
};
